import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { smoothNavigate } from 'components/SmoothNavigate';
import { useGroupPaymentCardInfo } from 'customHooks/useGroupPaymentCardInfo';

import {
  CreditCardDetailsContentContainer,
  CreditCardDetailsCardContainer,
  CreditCardDetailsButton,
} from './style';

const debug = false;

const CreditCardDetails: FC = () => {
  const history = useHistory();
  const { groupId } = useParams<{ groupId: string }>();

  const {
    holdAmount,
    maskedCardNumber,
    cardLastFourDigits,
    billingAddress,
    cardHolderName,
    expirationDate,
    loading,
    currentPaymentCard
  } = useGroupPaymentCardInfo(groupId);

  if (debug) {
    console.log('[CreditCardDetails]groupId = ', groupId);

  }


  const handleChangeCard = () => {
    smoothNavigate(history, `/account/billing/edit-credit-card/${groupId}`);
  };

  if (loading) {
    return null;
  }

  if (!currentPaymentCard) {
    return (
      <CreditCardDetailsContentContainer>
        <CreditCardDetailsCardContainer>
          <p className="description">
            No payment card found. Please contact our staff.
          </p>
        </CreditCardDetailsCardContainer>
      </CreditCardDetailsContentContainer>
    );
  }

  return (
    <CreditCardDetailsContentContainer>
      <CreditCardDetailsCardContainer>
        <p className="description">
          Your booking is currently linked to your card ending in: {cardLastFourDigits || '----'}.
          There is a hold placed on this card for a total of ${holdAmount}.<br />
          If you wish to change your card, we will place the same hold on the new card and then release the hold on your current card.
        </p>

        <div className="cardInfoRows">
          <div className="cardInfoRow">
            <div className="cardInfoLabel">NAME ON THE CARD</div>
            <div className="cardInfoValue">{cardHolderName}</div>
          </div>

          <div className="cardInfoRow">
            <div className="cardInfoLabel">CARD NUMBER</div>
            <div className="cardInfoValue">{maskedCardNumber}</div>
          </div>

          <div className="cardInfoRow">
            <div className="cardInfoLabel">EXPIRY (MM/YY)</div>
            <div className="cardInfoValue">{expirationDate}</div>
          </div>

          <div className="cardInfoRow">
            <div className="cardInfoLabel">BILLING ADDRESS</div>
            <div className="cardInfoValue">{billingAddress}</div>
          </div>
        </div>

        <CreditCardDetailsButton onClick={handleChangeCard}>
          Change Card
        </CreditCardDetailsButton>
      </CreditCardDetailsCardContainer>
    </CreditCardDetailsContentContainer>
  );
};

export default CreditCardDetails;